module.exports = __webpack_public_path__ + "img/quotes-error.f86093ce.svg";